"use client"

import React from 'react';
import styles from "./Spirituality.module.scss";
import {useAppStore} from "@/store/AppStore";
import {Prayer} from "@/types/Prayers";
import useSpiritualityData from "@/utils/hooks/useSpiritualityData";
import LoginAlert from "@/components/LoginAlert/LoginAlert";
import {Chip, Divider, Stack} from "@mui/material";
import {Link} from "@/i18n/routing";
import HikingIcon from "@mui/icons-material/Hiking";

export default function Spirituality(params: { currentId?: string }) {
  const {currentId} = params
  const user = useAppStore((state) => state.user);
  const data = useSpiritualityData(user?.access_token)

  const items = data?.items

  // `opened` deriva da `currentId` (formato `spirituality-<id>`).
  const opened = currentId?.includes("spirituality")
    ? Number(currentId.split("spirituality-")[1])
    : undefined


  if (!currentId) return null
  if (!currentId.includes("spirituality")) return null
  if (!user) return <LoginAlert/>

  const actives: Prayer[] | undefined = opened ? items?.filter((itm) => {
    return itm.id === opened
  }) : undefined

  const active = actives?.at(0)
  const segments = active?.segments

  return (
    <div className={styles.container}>
      <div className={styles.wrapper}>
        <div className={styles.contentWrapper}>
          {active && <div>
            <h2 className={styles.prayerTitle}>{active.name}</h2>
            {active.embed_content && <div style={{marginBottom: "1rem"}} dangerouslySetInnerHTML={{__html: String(active.embed_content)}}/>}
            <div dangerouslySetInnerHTML={{__html: String(active.content)}}/>
            {segments && segments.length > 0 && <>
                <Divider sx={{my: 5}}/>
                <Stack direction={"row"} sx={{gap: 2, flexWrap: "wrap"}}>{segments.map((item, key) => {
                  return <Link key={key} href={"/tappa/" + item.id}>
                    <Chip icon={<HikingIcon/>} size={"small"}
                          label={item.name}
                          color="primary"
                          variant="outlined"/>
                  </Link>
                })}</Stack>
            </>}
          </div>
          }
        </div>
      </div>
    </div>
  )
}
